import { gql } from "@apollo/client";

export const webSettingsQuery = gql`
  query WebSettings {
    viewer {
      user {
        orgs {
          edges {
            node {
              id
              experiments
              primaryOrgCalendar
              primaryTeam {
                __typename
                ... on Team {
                  teamId
                  teamName
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
              userTeams {
                __typename
                ... on TeamList {
                  list {
                    teamId
                    teamName
                  }
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
            }
          }
        }
      }
    }
  }
`;
